import { render, staticRenderFns } from "./MessageOverlay.vue?vue&type=template&id=8ab0d6e2&"
import script from "./MessageOverlay.vue?vue&type=script&lang=js&"
export * from "./MessageOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports